import React from 'react';
import { connect } from 'react-redux';
import { MenuItem } from 'react-contextmenu';
import { last } from 'lodash';

import { TreeItem } from 'components/GenericTree';
// @ts-ignore
import * as flowActions from 'store/services/flow/actions';
import { Path } from 'components/GenericTree/types';
import { useTreeActions } from '../TreeActionsContext';
import { SContainerSoftActions, SContextMenu } from './styled';

interface ExportedItem {
  id: string;
  name: string;
  isFolder: boolean;
}

interface Props {
  path: Path;
  item: TreeItem;
  open: () => void;
  edit: () => void;
  exportItem: ({ id }: ExportedItem) => void;
  toggle: () => void;
  deleteFolder: (item: TreeItem) => void;
  deleteFile: (item: TreeItem) => void;
  upload: (path: Path) => void;
  createNewTempFile: (item: { path?: string }) => void;
  createNewTempFolder: (item: { path?: string }) => void;
}

function ContextMenu({
  open,
  item,
  deleteFolder,
  deleteFile,
  toggle,
  edit,
  path,
  exportItem,
  upload,
  createNewTempFile,
  createNewTempFolder,
}: Props) {
  const { deleteNode } = useTreeActions();
  const deleteAction = () =>
    item.isFolder ? deleteFolder(item) : deleteFile(item);

  const exportAction = () =>
    exportItem({
      id: item.id,
      name: item.data.title,
      isFolder: !!item.isFolder,
    });

  const handleDelete = async () => {
    try {
      await deleteAction();
      deleteNode(item.id);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <SContextMenu id={item.id}>
      <SContainerSoftActions>
        <MenuItem
          attributes={{ 'data-test': 'open' }}
          onClick={item.isFolder ? toggle : open}
        >
          Open
        </MenuItem>

        <MenuItem attributes={{ 'data-test': 'rename' }} onClick={edit}>
          Rename
        </MenuItem>

        <MenuItem attributes={{ 'data-test': 'export' }} onClick={exportAction}>
          Export
        </MenuItem>

        {item.isFolder && (
          <MenuItem
            attributes={{ 'data-test': 'upload' }}
            onClick={() => {
              upload(path);
            }}
          >
            Upload
          </MenuItem>
        )}
      </SContainerSoftActions>

      {item.isFolder && (
        <SContainerSoftActions>
          <MenuItem
            attributes={{ 'data-test': 'create-file' }}
            onClick={() => {
              createNewTempFile({ path: last(path) });
            }}
          >
            Create File
          </MenuItem>

          <MenuItem
            attributes={{ 'data-test': 'create-folder' }}
            onClick={() => {
              createNewTempFolder({ path: last(path) });
            }}
          >
            Create Folder
          </MenuItem>
        </SContainerSoftActions>
      )}

      <MenuItem attributes={{ 'data-test': 'delete' }} onClick={handleDelete}>
        Delete
      </MenuItem>
    </SContextMenu>
  );
}

const mapDispatchToProps = {
  deleteFile: flowActions.deleteFile,
  deleteFolder: flowActions.deleteFolder,
  exportItem: flowActions.exportFileOrFolder,
  createNewTempFile: flowActions.createNewTempFile,
  createNewTempFolder: flowActions.createNewTempFolder,
};

export default connect(
  null,
  mapDispatchToProps,
)(ContextMenu);
